<template>
    <a-modal
        :title="`转移【${record ? record.name : ''}】的数据`"
        :visible="visible"
        centered
        @ok="on_ok"
        @cancel="on_cancel"
        :width="540"
        :confirmLoading="submitting"
        :ok-button-props="{ props: { disabled: !receive_id || !scope.length } }"
        :after-close="after_close"
    >
        <a-form-model>
            <a-form-model-item label="数据接受对象">
                <a-checkable-tag
                    :checked="item.id == receive_id"
                    class="r-checkbox checkbox-tag"
                    v-for="item in basic_data_user"
                    @change="on_click(item)"
                    :key="item.id"
                    >{{ item.name }}</a-checkable-tag
                >
            </a-form-model-item>

            <a-form-model-item label="转移内容">
                <a-checkbox-group v-model="scope">
                    <a-checkbox value="member">
                        客户
                    </a-checkbox>
                    <a-checkbox value="resource">
                        店铺
                    </a-checkbox>
                </a-checkbox-group>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    import basic_data from "../../../mixins/basic_data";
    export default {
        mixins: [basic_data],
        props: {
            visible: false,
            callback: null,
            record: null,
        },
        data() {
            return {
                receive_id: null,
                submitting: false,
                scope: [],
            };
        },
        mounted() {
            this.load_basic_user();
        },
        methods: {
            on_ok() {
                this.submitting = true;
                this.$http
                    .post(`/auth/user/transfer`, {
                        to_user_id: this.receive_id,
                        from_user_id: this.record.id,
                        scope: this.scope,
                    })
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.on_cancel();
                            if (callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.receive_id = null;
                this.scope = [];
            },
            on_cancel() {
                this.$emit("close");
            },
            on_click(e) {
                this.receive_id = e.id;
            },
        },
    };
</script>
<style lang="less" scoped>
    .r-checkbox {
        cursor: pointer;
        margin-bottom: 12px;
    }
</style>
